import "../css/Reserve.css"
import { Helmet } from 'react-helmet';

export const Reserve = () => {
  return (
    <div style={{ "padding": "5%" }}>
      <Helmet>
        <title>予約状況|有明海・大牟田市三池港発釣り船 【シーラインⅢ】</title>
        <meta name="description" content="シーラインⅢの予約状況をお知らせしています。" />
        <meta name="keywords" content="予約状況, 遊漁船,シーラインⅢ 予約" />
        <meta property="og:url" content="https://sealine3-new.web.app/Reserve" />
        <link rel="canonical" href="https://sealine3-new.web.app/Reserve" />
      </Helmet>
      <h1>空き状況</h1>
      <h3>ご予約受付を始めました</h3>
      <p style={{ 'fontSize': '20px', 'marginLeft': '20px' }}>
        定員は12名ですが、釣りのご予約は定員10名までとさせていただきます。<br />
        本業の都合が合えば一人でも出港致します。（近海）<br />
        お気軽にお問い合わせください。<br />
        ご予約はお電話でのみ、受け付けをさせて頂ます。<br />
        (TEL)070-4287-0007<br />
        (E-mail)sealine3@outlook.jp
      </p>
      <iframe title="google calender" className="Reserve" src="https://calendar.google.com/calendar/embed?src=775ed54b85a51344717f80d80630a2702e10a8369106839f27259c1171625b22%40group.calendar.google.com&ctz=Asia%2FTokyo"></iframe>
    </div>
  );
};
